import Auth from '../auth';

const authHeaders = () => {
  const data = Auth.getAuthData();
  if (!data) return {};
  return {
    'access-token': data['access-token'],
    'token-type': data['token-type'],
    client: data.client,
    expiry: data.expiry,
    uid: data.uid,
  };
};

const request = async (accountId, action, payload) => {
  try {
    const response = await fetch(
      `/api/v1/accounts/${accountId}/aceleres/funnel_assistant/${action}`,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...authHeaders(),
        },
        body: JSON.stringify(payload),
      }
    );
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.success === false) {
      throw new Error(data.message || 'Não foi possível processar a proposta.');
    }
    return data;
  } catch (error) {
    throw new Error(error?.message || 'Não foi possível processar a proposta.');
  }
};

export const generateFunnelProposal = (accountId, description) =>
  request(accountId, 'generate', { description });

export const applyFunnelProposal = (accountId, proposal) =>
  request(accountId, 'apply', { proposal });
